"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _objectSpread2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _articleManage = require("@/api/_homeCloudPlatform/article/articleManage.js");
var _commodityManage = require("@/api/_homeCloudPlatform/mall/commodityManage.js");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _Editor = _interopRequireDefault(require("@/components/Editor"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var formModel = {
  labels: []
};
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    Editor: _Editor.default
  },
  computed: {
    rules: function rules() {
      var _this = this;
      return {
        title: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }, {
          max: 64,
          message: '输入长度不能超过64位'
        }],
        publication_date: [{
          required: true,
          message: '请输入发布日期',
          trigger: 'blur'
        }],
        'previewImg': {
          required: true,
          validator: function validator(rule, value, callBack) {
            if (!_this.previewImg.image) {
              callBack('请选择图片');
            } else {
              callBack();
            }
          }
        },
        content: [{
          required: true,
          message: '请输入内容',
          trigger: 'blur'
        }],
        sorting: [{
          validator: function validator(rule, value, callBack) {
            // -10000 ~ 10000
            if (value * 1 > 9999) {
              callBack('输入的数字不应大于9999');
            } else {
              callBack();
            }
          }
        }]
      };
    },
    dialogTitle: function dialogTitle() {
      var type = '';
      switch (this.dialogType) {
        case 'view':
          type = '检视';
          break;
        case 'add':
          type = '新增';
          break;
        case 'edit':
          type = '编辑';
          break;
      }
      return "".concat(type, "\u6587\u7AE0");
    }
  },
  watch: {
    dialogType: {
      immediate: true,
      handler: function handler(val) {
        this.disabled = val !== 'edit' && val !== 'add';
      }
    }
  },
  data: function data() {
    return {
      formModel: formModel,
      disabled: false,
      tableData: {},
      listLoading: true,
      // 預設排序,依發佈時間遞減
      defaultOrdering: '-publication_date',
      listQuery: {
        page: 1,
        page_size: 20,
        page_size_before: 20
      },
      dialogVisible: false,
      dialogType: 'view',
      previewImg: {},
      // 狀態選項
      statusOptions: [{
        key: 'all',
        display_name: '全部',
        value: 'all'
      }, {
        key: 'true',
        display_name: '上架',
        value: true
      }, {
        key: 'false',
        display_name: '下架',
        value: !true
      }],
      // 類型
      typeOptions: [{
        key: 0,
        display_name: '全部'
      }, {
        key: 1,
        display_name: 'TTS频道'
      }, {
        key: 2,
        display_name: '视频分享'
      }, {
        key: 3,
        display_name: '新闻资讯'
      }, {
        key: 4,
        display_name: '新冠专题'
      }],
      tagsList: [],
      // 链结商品
      linkedProductsOptions: []
    };
  },
  created: function created() {
    this.handleSort();
    this.getTagsList();
    this.getGoodsList();
    this.getList();
  },
  methods: {
    checkPermission: _permission.default,
    getList: function getList(e) {
      var _this2 = this;
      this.listLoading = true;
      if (e && this.listQuery.page_size_before != e.limit) {
        this.listQuery.page = 1;
        this.listQuery.page_size_before = e.limit;
      }
      (0, _articleManage.getNewsList)(this.handleQuery()).then(function (res) {
        _this2.tableData = res || {};
        _this2.listLoading = false;
      });
    },
    // 標籤清單
    getTagsList: function getTagsList() {
      var _this3 = this;
      (0, _commodityManage.getTagsList)().then(function (res) {
        _this3.tagsList = res.results.filter(function (item) {
          return item.type === 0;
        }) || [];
        _this3.tagsList.unshift({
          name: '全部',
          id: ''
        });
      });
    },
    getGoodsList: function () {
      var _getGoodsList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _this4 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _commodityManage.getGoodsListLight)({
                page: 1,
                page_size: 1,
                product_status: 1,
                //上架
                goods_type: 1 //C端商品
              }).then(/*#__PURE__*/function () {
                var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(data) {
                  return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (data.count) {
                          _context.next = 2;
                          break;
                        }
                        return _context.abrupt("return");
                      case 2:
                        _context.next = 4;
                        return (0, _commodityManage.getGoodsListLight)({
                          page_size: data.count,
                          //取全部
                          product_status: 1,
                          goods_type: 1
                        }).then(function (res) {
                          _this4.linkedProductsOptions = res.results;
                        });
                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getGoodsList() {
        return _getGoodsList.apply(this, arguments);
      }
      return getGoodsList;
    }(),
    handleAdd: function handleAdd() {
      var _this5 = this;
      this.formModel = JSON.parse(JSON.stringify(formModel));
      this.handleInitData();
      this.dialogType = 'add';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this5.$refs['Form'].clearValidate();
      });
    },
    handleView: function handleView(scope) {
      var _this6 = this;
      this.formModel = JSON.parse(JSON.stringify(scope.row));
      this.handleInitData();
      this.dialogType = 'view';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this6.$refs['Form'].clearValidate();
      });
    },
    handleEdit: function handleEdit(scope) {
      var _this7 = this;
      this.formModel = JSON.parse(JSON.stringify(scope.row)); // copy obj
      this.handleInitData();
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this7.$refs['Form'].clearValidate();
      });
    },
    // 初始化資料處理
    handleInitData: function handleInitData() {
      this.previewImg = {
        image: this.formModel.image_url
      };
      if (this.formModel.labels.length) {
        var arr = [];
        this.formModel.labels.forEach(function (item) {
          arr.push(item.name);
        });
        this.formModel.labels = arr;
      }
      if (this.formModel.goods && this.formModel.goods.length > 0) {
        var arr2 = [];
        this.formModel.goods.forEach(function (item) {
          arr2.push(item.id);
        });
        this.formModel.goods = arr2;
      }
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(form) {
        var _this8 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this8.dialogType === 'edit';
                  if (isEdit) {
                    (0, _articleManage.updateNews)(_this8.formModel.id, _this8.handleFormData()).then(function (res) {
                      if (res.status_code !== 200) {
                        return _this8.errorHandle(res);
                      }
                      _this8.getList();
                      _this8.dialogVisible = false;
                      _this8.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    });
                  } else if (_this8.dialogType === 'add') {
                    (0, _articleManage.createNews)(_this8.handleFormData()).then(function (res) {
                      if (res.status_code !== 200) {
                        return _this8.errorHandle(res);
                      }
                      _this8.getList();
                      _this8.dialogVisible = false;
                      _this8.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function confirm(_x2) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var _this9 = this;
      // const isLt2M = file.size / 1024 / 1024 < 0.2
      // if (!isLt2M) {
      //   this.$message.error('上传图片大小不能超过 200kb!')
      // } else {
      var reader = new FileReader();
      reader.onload = function (e) {
        // 打API上傳圖片
        var formdata = new FormData();
        formdata.append('file', file);
        (0, _articleManage.createNewsImage)(formdata).then(function (res) {
          _this9.previewImg = {
            // image: e.target.result, //直接讀取
            image: "".concat(res.data.urls),
            //從API res讀取
            path: "".concat(res.data.path)
          };
        });
      };
      reader.readAsDataURL(file);
      // }
      return isLt2M;
    },
    removeImg: function removeImg() {
      this.previewImg = {};
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        page_size: this.listQuery.page_size
      };
      this.getList();
    },
    handleQuery: function handleQuery() {
      var query = (0, _objectSpread2.default)({}, this.listQuery);
      if (query.label_id === '' || query.label_id === 'all') {
        query.label_id = function () {
          return;
        }();
      }
      if (query.type == '0') {
        query.type = function () {
          return;
        }();
      }
      return query;
    },
    handleFormData: function handleFormData() {
      var _this10 = this;
      var arr = [];
      this.formModel.labels.forEach(function (item) {
        arr.push({
          name: item
        });
      });
      if (this.previewImg.path) {
        this.formModel.image = this.previewImg.path;
      }
      this.formModel['content'] = this.$refs.editor.handlehtml(this.formModel['content']);
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.formModel), {}, {
        labels: arr,
        status: function () {
          if (_this10.dialogType === 'edit') return _this10.formModel.status;
          return;
        }()
      });
      return params;
    },
    handleSort: function handleSort(column) {
      // 初始化處理
      if (!column) {
        this.listQuery.ordering = this.listQuery.ordering || this.defaultOrdering;
        return {
          prop: this.defaultOrdering.indexOf('-') !== -1 ? this.defaultOrdering.split('-')[1] : this.defaultOrdering,
          order: this.defaultOrdering.indexOf('-') !== -1 ? 'descending' : 'ascending'
        };
      }
      // 點擊排序
      else {
        this.listQuery.page = 1;
        this.listQuery.ordering = column.order ? "".concat(column.order === 'descending' ? '-' : '').concat(column.prop) : this.defaultOrdering;
        this.getList();
      }
    }
  }
};